module.exports = __webpack_public_path__ + "static/media/花絮05.19.939f0451.mp4";